var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4209 105C14.283 107.96 15.0097 113.334 17.3889 115.537",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.369 23.4444L185.362 18.8291",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.316 132.594C128.936 116.756 134.433 85.5782 118.594 62.958C118.274 62.4998 117.947 62.0487 117.613 61.6046C100.788 48.9995 77.1142 47.9645 58.9553 60.6795C36.3351 76.5184 30.8377 107.696 46.6766 130.316C46.9974 130.774 47.3245 131.225 47.6576 131.669C64.4835 144.274 88.1568 145.309 106.316 132.594Z",
    fill: "#838B98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.216 40.6239C113.958 43.1676 116.15 45.289 116.919 47.5967",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149 63.1708C150.233 54.0781 160.019 45.331 169.415 46.9304C176.046 48.059 183 55.1708 175.297 59.1704C165 63.1708 166.748 52.3778 167 50.1708C167.739 43.7072 177.167 39.7762 182.394 38.8627C186.239 38.1907 189.905 38.0005 193.803 38.0005",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.246 12.4591C120.258 18.8313 125.976 29.6557 134.244 29.3795C136.574 29.3016 139.296 28.2746 136.609 26.3096C135.029 25.1539 133.399 25.9182 132.111 27.0034C129.362 29.321 129.087 31.3334 129.717 34.7969C130.379 38.4346 132.985 42.1619 135.484 44.8352",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.731 75.6158C174.731 77.2816 173.37 78.7312 171.615 78.7312C169.861 78.7312 168.5 77.2816 168.5 75.6158C168.5 73.9827 169.982 72.5005 171.615 72.5005C173.248 72.5005 174.731 73.9827 174.731 75.6158Z",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7307 91.6158C12.7307 93.2816 11.3699 94.7312 9.61534 94.7312C7.86073 94.7312 6.5 93.2816 6.5 91.6158C6.5 89.9827 7.98225 88.5005 9.61534 88.5005C11.2484 88.5005 12.7307 89.9827 12.7307 91.6158Z",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.956 64.105C132.161 85.8205 126.884 115.751 105.168 130.956C83.4526 146.161 53.5225 140.884 38.3171 119.168C23.1118 97.4529 28.3893 67.5227 50.1048 52.3174C71.8202 37.1121 101.75 42.3896 116.956 64.105Z",
    stroke: "#313D53",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.877 183.217C135.972 183.85 134.725 183.63 134.091 182.726L100.252 134.398L110.082 127.515L143.921 175.843C144.554 176.748 144.335 177.995 143.43 178.628L136.877 183.217Z",
    fill: "#838B98",
    stroke: "#313D53",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.878 183.217C135.973 183.851 134.726 183.631 134.092 182.726L123.765 167.978L133.595 161.095L143.922 175.843C144.555 176.748 144.336 177.995 143.431 178.629L136.878 183.217Z",
    fill: "white",
    stroke: "#313D53",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4492 152.875L20.874 145.001L12.9991 156.576C19.3919 160.925 28.1 159.268 32.4492 152.875Z",
    fill: "#E9688A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.293 36.7642L164.765 27.4723L155.473 17.0004C149.69 22.1321 149.161 30.9807 154.293 36.7642Z",
    fill: "#E9688A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f22804423f1a976b07df270d9fe99ed9.svg";
export { ForwardRef as ReactComponent };